export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["المجموع"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["النتيجة"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["المعاملة"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["تحديث الحالة"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["روابط مفيدة"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["البلوكشين:"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["قيد التنفيذ"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["نجح"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["فشل"])}
}